import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TermFullUWCoverageLengths } from "../../../../Helpers/Data/Products/Term/FullUWCoverageLengths";
import AboutMeMinimalForm from "../../../../Quoters/CustomizeTerm/steps/AboutMeMinimalForm";
import HeroData from "./HeroData";
import AboutData from "./AboutData";
import PartnerSupportData from "./PartnerSupportData";
import ServiceValueData from "./ServiceValueData";
import CompareProductsData from "./CompareProductsData";
import EducationData from "./EducationData";
import PurchasingProcessData from "./PurchasingProcessData";
import FaqData from "./FaqData";
import PrivacyData from "./PrivacyData";
import CtaData from "./CtaData";
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../../sessionStorage';
import { getPrimaryColor } from "../../../../Quoters/Common/Helpers/Utility";

export default function TermData(props) {
  const primaryBrandColor = getPrimaryColor();
  const [isContactSpecialist, setIsContactSpecialist] = useState(false);
  const [emailCaptureActive, setEmailCaptureActive] = useState(false);
  const [triggerNext, setTriggerNext] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const termNavigationState = props.isSimplifiedIssueTerm ? { state: { isFromSimplifiedIssueTerm: true } } : undefined;

  const aboutData = {
    minAge: 18,
    maxAge: 70,
    minCoverageAmount: 50000,
    maxCoverageAmount: 10000000,
    termFullUWCoverageLengths: TermFullUWCoverageLengths(),
  };

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const accountName = (accountObj.accountDisplayName && accountObj.accountDisplayName !== "") ? 
    accountObj.accountDisplayName : accountObj.account.accountName;
  const accountProductTypeSettings = accountObj.accountProducts.find(product => props.isSimplifiedIssueTerm
    ? product.productLandingUrl === '/landing/simplified-issue-term'
    : product.productLandingUrl === location.pathname);
  const accountLandingOverride = accountObj.accountOverrides && accountProductTypeSettings ?
    accountObj.accountOverrides.find(override => override.accountProductTypeId === accountProductTypeSettings.productTypeId) : null;
  const isPreQuoteEnabled = accountObj?.account?.enableTermPreQuote;

  useEffect(() => {
    if (triggerNext && !emailCaptureActive) {
      navigate(isPreQuoteEnabled ? '/term-insurance/prequote' : '/term-insurance/quote-results', termNavigationState);
    }
  }, [triggerNext, emailCaptureActive, isPreQuoteEnabled, props.isSimplifiedIssueTerm]);

  const termForm = (<AboutMeMinimalForm
    ageSpecs={{ min: aboutData.minAge, max: aboutData.maxAge }}
    onNext={() => {
      setTriggerNext(true);
    }}
    handleExpandForm={props.handleExpandForm}
    brandTheme={primaryBrandColor}
    submitButtonVariant={'landing'}
    stackForm={props.stackForm}
    ref={props.aboutMeFormRef}
    isContactSpecialist={isContactSpecialist}
    setIsContactSpecialist={setIsContactSpecialist}
    setEmailCaptureActive={setEmailCaptureActive}
    isPreQuoteEnabled={isPreQuoteEnabled}
    isSimplifiedIssueTerm={props.isSimplifiedIssueTerm}
  />);

  return {
    name: 'Term Life Insurance',
    basicInfoForm: termForm,
    heroData: {
      custom: accountLandingOverride ? JSON.parse(accountLandingOverride.valueProposition) : null,
      default: HeroData(),
    },
    aboutData: AboutData(),
    partnerSupportData: PartnerSupportData(accountName),
    serviceValueData: ServiceValueData(),
    compareProductsData: CompareProductsData(),
    purchasingProcessData: PurchasingProcessData(),
    educationData: EducationData(),
    faqData: FaqData(),
    privacyData: PrivacyData(),
    ctaData: CtaData(accountName, isContactSpecialist),
    brandTheme: primaryBrandColor,
    isAddDefaultFaq: false,
    showTestimonialPanel: accountObj.account.isTestimonialPanelEnable,
    setEmailCaptureActive: setEmailCaptureActive,
  };
}
